import { getPackageBaseUrl } from 'owa-config';
import { Md5 } from 'ts-md5/dist/md5';

/**
 * A list of known doughboy MD5 hashes
 */
const DOUGHBOY_MD5: string[] = [
    '0381c1bcfc0b809623b805e322dd9fa1',
    '03d374b16722d252588fa2d58a3e828d',
    '083313c7a8083e625c0def330dbd7cdd',
    '0f78c3aa1a3da070d8f62bb9a2ee76ae',
    '1778a41789eadf72ff596815bd4a8142',
    '20f0b5fb7de21fa889b002714ec58f20',
    '2149d6090d915f849f5c33c07545fb03',
    '241b2579d59d10255b2e405fbcbb9117',
    '279ec9ccb88c02985b4e1f645b755faf',
    '2d1f23069e16bf5e1eaed1b4c03be39c',
    '2fce211aefcaec7742455aa616edfa32',
    '3178a5744ef0cd2b61757583d7b7ccf1',
    '319f83a0e835d32ce2660a4de654a7c0',
    '4a48f26592f4e1498d7a478a4c48609c',
    '41ebba55d20ff0a87734a09d88dc8f27',
    '613c9c11d6bfdec3dd2a568412b79762',
    '62fe9bb236110e4553483b02e1989986',
    '6fe016add870f202c0a30c70ee943c73',
    '7ad602295f8386b7615b582d87bcc294',
    '8193ab3946149e9175a3c3d44219e9e1',
    '8a2bceaca7e84b8f4da535d772625c6f',
    '8ddba906d9614422695d3c9756afee7f',
    '9029ea4d3ee7796fe043710dfff1d218',
    '98f88501895b89e844d24793dadc8a9f',
    '9a85f4ab720503d37748e2d854a238dc',
    'b3b9212834745aa4457f459f12e56653',
    'c065f1d4e77c3678be1ff6aa835dda69',
    'c90802ef1184641e2943446f37b6e09f',
    'ebaafd3a5e1de52fc789151123ebb6ab',
    'f0d90ca687e974534dfc12798166c7e6',
    'ffb18190d6e56748b5d6d743ff7421ad',
];

const DATA_URL_PREFIX = 'data:image/png;base64,';

/**
 * This checks the image is a doughboy.
 * @param img: A loaded HTML image element
 */
export function isDoughboy(img: HTMLImageElement): boolean {
    if (!img || !img.src) {
        return false;
    }

    const fingerprint = getFingerprint(img);
    if (!fingerprint) {
        return false;
    }

    return DOUGHBOY_MD5.some(el => el === fingerprint);
}

/**
 * This checks if the image is a 1x1 image.
 * @param img A loaded HTML image element
 */
export function is1x1Image(img: HTMLImageElement): boolean {
    return img && img.naturalHeight === 1 && img.naturalWidth === 1;
}

/**
 * Returns the md5 fingerprint of the image. If the image is from another domain,
 * it will return empty.
 * @param img A loaded HTML image element
 */
function getFingerprint(img: HTMLImageElement): string | null {
    if (!img) {
        return null;
    }

    const imageDataURL: string = getImageDataURL(img).slice(DATA_URL_PREFIX.length);

    return !imageDataURL ? '' : (Md5.hashStr(imageDataURL) as string);
}

/**
 * Returns image converted to base64
 * @param img A loaded HTML image element
 */
function getImageDataURL(img: HTMLImageElement): string {
    if (!img || img.src === '' || (img.naturalHeight === 0 && img.naturalWidth === 0)) {
        return '';
    }

    const canvas = document.createElement('canvas');
    canvas.width = img.naturalWidth;
    canvas.height = img.naturalHeight;
    const ctx = canvas.getContext('2d');
    if (!ctx) {
        return '';
    }

    ctx.drawImage(img, 0, 0);
    try {
        return canvas.toDataURL('image/png');
    } catch (error) {
        // The canvas is probably tainted, due to an image from another domain.
        return '';
    }
}

export function getImageResourcePath(fileName: string): string {
    return `${getPackageBaseUrl()}resources/images/${fileName}`;
}
